import type { BaseEntity, SimpleFieldConfig, SimpleTableConfig } from "../../../UniversalCRMTable/types";

export interface FieldRowProps<T extends BaseEntity> {
  fieldId: string;
  fieldConfig: SimpleFieldConfig;
  value: unknown;
  isFieldEditing: boolean;
  canEdit: boolean;
  isFullscreen: boolean;
  item: T;
  config: SimpleTableConfig<T>;
  onFieldEdit: (fieldId: string) => void;
  onSaveField: (fieldId: string, newValue?: unknown) => Promise<void>;
  onCancelEdit: () => void;
  onFieldValueChange: (fieldId: string, newValue: unknown) => void;
}

/**
 * Only re-render if the specific field value or editing state changes.
 * This prevents re-renders when other fields are edited.
 */
export function areFieldRowPropsEqual<T extends BaseEntity>(
  prevProps: FieldRowProps<T>,
  nextProps: FieldRowProps<T>
): boolean {
  if (prevProps.fieldId !== nextProps.fieldId) return false;
  if (prevProps.isFieldEditing !== nextProps.isFieldEditing) return false;
  if (prevProps.canEdit !== nextProps.canEdit) return false;
  if (prevProps.isFullscreen !== nextProps.isFullscreen) return false;
  if (prevProps.fieldConfig !== nextProps.fieldConfig) return false;

  if (typeof prevProps.value === "object" && typeof nextProps.value === "object") {
    if (JSON.stringify(prevProps.value) !== JSON.stringify(nextProps.value)) {
      return false;
    }
  } else if (prevProps.value !== nextProps.value) {
    return false;
  }

  return true;
}
